import React from 'react';
import { Title } from './styles';

export type NotitificationTitleProps = {
  title: string;
};

export const NotificationTitle = ({ title }: NotitificationTitleProps) => {
  return <Title>{title}</Title>;
};
